var _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarpLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1.625in",
    height: "0.25in",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    kerning: "auto",
    fontFamily: "Myriad Pro",
    fill: "rgb(0, 0, 0)",
    fontSize: "25px",
    x: "0px",
    y: "17.9250000000002px"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: "25px",
    fontFamily: "Montserrat",
    fontVariant: "small-caps",
    fill: "#FFFFFF"
  }, "Carpen"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: "25px",
    fontFamily: "Montserrat",
    fontVariant: "small-caps",
    fill: "#A73030"
  }, "ko"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpLogo);
export default __webpack_public_path__ + "static/media/carp-logo.caaefb96ad83337e0d8e17297f0b99fa.svg";
export { ForwardRef as ReactComponent };